import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useSelector } from "react-redux";
import {
  getServiceChargeInvoiceProcessSelectionModel,
  saveServiceChargeInvoiceProcessSelectionModel,
  selectIsBackgroundProcessRunning,
  selectLoadingServiceChargeInvoice,
  selectServiceChargeInvoice,
  selectServiceChargeInvoiceCurrentStep,
  setServiceChargeInvoiceModel,
} from "./ServiceChargeInvoicingSlice";
import { useEffect, useState } from "react";
import { ServiceChargeInvoicingWizardMapping } from "./ServiceChargeInvoiceWizardSteps";
import { WizardProgressBar } from "app/modules/shared/wizard/WizardProgressBar";
import { WizardStepViewer } from "app/modules/shared/wizard/WizardStepViewer";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { useDispatch } from "react-redux";

const ServiceChargeInvoiceWizard: React.FC = () => {
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const data = useSelector(selectServiceChargeInvoice);
  const currentStep = useSelector(selectServiceChargeInvoiceCurrentStep);
  const loadingServiceChargeInvoice = useSelector(selectLoadingServiceChargeInvoice);
  const isBackgroundProcessRunning = useSelector(selectIsBackgroundProcessRunning);

  const [initialLoad, setInitialLoad] = useState<boolean>(true);
  const steps = ServiceChargeInvoicingWizardMapping;

  useEffect(() => {
    if (initialLoad) {
      thunkDispatch(getServiceChargeInvoiceProcessSelectionModel());
    }
    setInitialLoad(false);
  }, [initialLoad, thunkDispatch]);

  useEffect(() => {
    if (
      !initialLoad &&
      !loadingServiceChargeInvoice &&
      !isBackgroundProcessRunning &&
      currentStep != data.currentStep
    ) {
      dispatch(setServiceChargeInvoiceModel({ ...data, currentStep: currentStep }));
      thunkDispatch(saveServiceChargeInvoiceProcessSelectionModel());
    }
  }, [
    dispatch,
    thunkDispatch,
    initialLoad,
    loadingServiceChargeInvoice,
    isBackgroundProcessRunning,
    currentStep,
    data,
  ]);

  return (
    <div className="card d-inline-flex mb-6">
      <div className="card-header">
        <div className="card-title">Service Charge Invoicing</div>
      </div>
      <div className="card-body">
        <ActivityIndicator isBusy={loadingServiceChargeInvoice || isBackgroundProcessRunning}>
          <WizardProgressBar currentStep={currentStep} totalSteps={steps.length} />
          <WizardStepViewer CurrentStep={currentStep} Steps={steps} />
        </ActivityIndicator>
      </div>
    </div>
  );
};

export default ServiceChargeInvoiceWizard;
